var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.squad)?_c('squad-form',{attrs:{"squad":_vm.squad}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }